import './pro.css';
import saveTime from './saveTime.svg';
import contactless from './contactless.svg';
import result from './result.svg';
import { checkRU } from '../../index';

const ProList = () => {
    const { isRu, apiUrl } = checkRU();
    const saveTimeMessage = isRu ? "Экономия времени" : "Економія часу";
    const contactlessMessage = isRu ? "Отсутсвие лишних контактов" : "Відсутність зайвих контактів";
    const resultMessage = isRu ? "Заключение в онлайн-кабинете" : "Заключення в онлайн-кабінеті";

    return (
        <div className="pros-list-container">
            <div className="pro-container">
                <div><img src={saveTime} className="pro-image" alt="saveTime" /></div>
                <div className="pro-text">{saveTimeMessage}</div>
            </div>
            <div className="pro-container">
                <div><img src={contactless} className="pro-image" alt="contactless" /></div>
                <div className="pro-text">{contactlessMessage}</div>
            </div>
            <div className="pro-container">
                <div><img src={result} className="pro-image" alt="result" /></div>
                <div className="pro-text">{resultMessage}</div>
            </div>
        </div>
    );
}

export default ProList;